import { Observable } from "../Observable.js";
function distinctUntilChanged(comparator) {
  return (source) => {
    return new Observable((subscriber) => {
      let hasValue = false;
      let previousValue;
      const subscription = source.subscribe({
        next: (value) => {
          const areEqual = hasValue ? comparator ? comparator(previousValue, value) : previousValue === value : false;
          if (!areEqual) {
            hasValue = true;
            previousValue = value;
            subscriber.next(value);
          }
        },
        error: (err) => {
          subscriber.error(err);
        },
        complete: () => {
          subscriber.complete();
        }
      });
      return subscription;
    });
  };
}
export {
  distinctUntilChanged
};
//# sourceMappingURL=distinctUntilChanged.js.map
